import objectUtils from '../utils/object-utils'

export default class Receiver {
  constructor (options = {}) {
    this.model = 'Receiver'

    this.id = objectUtils.get(options, 'id', null)
    this.alias = objectUtils.get(options, 'alias', null) // a url safe alias
    this.name = objectUtils.get(options, 'name', null)
    this.dba = objectUtils.get(options, 'dba', null)
    this.legal_entity_name = objectUtils.get(options, 'legal_entity_name', null)

    // Licenses / certificates
    this.establishment_license_number = objectUtils.get(options, 'establishment_license_number', null)
    this.establishment_license_category = objectUtils.get(options, 'establishment_license_category', null)
    this.establishment_license_issue_date = objectUtils.get(options, 'establishment_license_issue_date', null)
    this.establishment_license_expiration = objectUtils.get(options, 'establishment_license_expiration', null)
    this.establishment_license_amended_date = objectUtils.get(options, 'establishment_license_amended_date', null)
    this.drc_number = objectUtils.get(options, 'drc_number', null)
    this.drc_category = objectUtils.get(options, 'drc_category', null)
    this.drc_issue_date = objectUtils.get(options, 'drc_issue_date', null)
    this.drc_expiration = objectUtils.get(options, 'drc_expiration', null)
    this.drc_amended_date = objectUtils.get(options, 'drc_amended_date', null)
    this.saved_establishment_license = objectUtils.get(options, 'saved_establishment_license', false)
    this.saved_drc = objectUtils.get(options, 'saved_drc', false)
    this.license_for_shipping_address = objectUtils.get(options, 'license_for_shipping_address', null)
    this.license_docs = objectUtils.get(options, 'license_docs', {})

    // Contact, notes, and availability
    this.description = objectUtils.get(options, 'description', null)
    this.email = objectUtils.get(options, 'email', null)
    this.phone = objectUtils.get(options, 'phone', null)
    this.phone_secondary = objectUtils.get(options, 'phone_secondary', null)
    this.fax = objectUtils.get(options, 'fax', null)
    this.timezone = objectUtils.get(options, 'timezone', null)
    this.notes = objectUtils.get(options, 'notes', null)
    this.settings = objectUtils.get(options, 'settings', {})
    this.coords = objectUtils.get(options, 'coords', {})
    this.requires_appointment = objectUtils.get(options, 'requires_appointment', false)
    this.appointment_url = objectUtils.get(options, 'appointment_url', null)
    this.available_times = objectUtils.get(options, 'available_times', null)

    // Address of shipping location
    this.street_1 = objectUtils.get(options, 'street_1', null)
    this.street_2 = objectUtils.get(options, 'street_2', null)
    this.city = objectUtils.get(options, 'city', null)
    this.state = objectUtils.get(options, 'state', null)
    this.zip = objectUtils.get(options, 'zip', null)
    this.postal_code = objectUtils.get(options, 'postal_code', null)
    this.country = objectUtils.get(options, 'country', null)

    // Status and auditing
    this.pending_changes = objectUtils.get(options, 'pending_changes', null)
    this.receiver_status = objectUtils.get(options, 'receiver_status', null)
    this.created_by = objectUtils.get(options, 'created_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.last_submitted_by = objectUtils.get(options, 'last_submitted_by', null)
    this.last_submitted_at = objectUtils.get(options, 'last_submitted_at', null)
    this.deactivated_by = objectUtils.get(options, 'deactivated_by', null)
    this.deactivated_at = objectUtils.get(options, 'deactivated_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.org) this.org = options.org
    if (options.recipient_emails) this.recipient_emails = options.recipient_emails
    if (options.approved_licenses) this.approved_licenses = options.approved_licenses
  }
}
